import {controllers} from '@mintdata-wsp/wsp/controllers/WspControllers';
import * as classnames from 'classnames/bind';
import * as React from 'react';
import {observer} from 'mobx-react';
import {HotKeys} from 'react-hotkeys';

const styles = require('./SurfaceKeyboardShortcuts.less');
const cx = classnames.bind(styles);

interface ISurfaceKeyboardShortcutsProps
{
    className?:string;
    keyMap?:any;
    keyHandlers?:any;
}

@observer
export class SurfaceKeyboardShortcuts extends React.Component<ISurfaceKeyboardShortcutsProps, any>
{
    render()
    {
        const {surfaceArea, surfaceKeyboard} = controllers.ui;

        const keyMap = this.props.keyMap || surfaceKeyboard.getKeyMap();
        const keyHandlers = this.props.keyHandlers || surfaceKeyboard.getKeyHandlers();
        const isPreviewMode:boolean = surfaceArea.isInPreviewOrZenPreviewMode();

        return (
            <HotKeys
                className={cx('base', this.props.className)}
                keyMap={!isPreviewMode ? keyMap : {}}
                handlers={!isPreviewMode ? keyHandlers : {}}
                onMouseEnter={surfaceKeyboard.handleSurfaceMouseEnter}
                onFocus={surfaceKeyboard.handleSurfaceFocus}
            >
                {this.props.children}
            </HotKeys>
        );
    }
}
